import React from 'react';
import { agrupaTopN, dominante, larguras } from './calculos';
import { formataNumero, formataPct } from './formata';
import './painel.css';

// Lista com barra horizontal ordenada: os N maiores + "Outros".
// Quando um item passa de 80% do total, vira frase + lista — uma barra
// gigante ao lado de lascas não informa nada.
// A barra é decorativa (aria-hidden); o número em texto é o que se lê.
// `formata` troca a formatação dos números; `aoClicar` torna o rótulo um link
// (item com `clicavel: false` fica texto — não há para onde levar).
// `i.cor` troca a cor de um item (ex.: órgão de força em azul, os demais em
// cinza, como no resto do Painel de Efetivo); sem ela, vale `cor`.
export default function ListaBarras({
  itens, topN = 4, rotuloOutros = 'Outros', cor = 'var(--painel-a)', destaque, formata = formataNumero, aoClicar,
}) {
  if (!itens.length) return <p className="text-muted mb-0">Nenhum.</p>;
  // Rótulo clicável quando há aoClicar — nos dois modos (barras e item dominante);
  // antes o modo dominante perdia os links (#395).
  const rotuloDe = (i) => (aoClicar && !i.outros && i.clicavel !== false ? (
    <button
      type="button"
      className="btn btn-link p-0 m-0 text-left"
      style={{ fontSize: 'inherit', textTransform: 'none', boxShadow: 'none' }}
      onClick={() => aoClicar(i)}
    >
      {i.rotulo}
    </button>
  ) : (i.outros ? `${i.rotulo} (${i.quantos})` : i.rotulo));
  const dom = dominante(itens, 0.8);
  const total = itens.reduce((s, i) => s + i.n, 0);

  if (dom) {
    const resto = itens.filter((i) => i.rotulo !== dom.rotulo).sort((a, b) => b.n - a.n);
    return (
      <>
        <p className="mb-2">
          <strong>{rotuloDe(itens.find((i) => i.rotulo === dom.rotulo))}: {formata(dom.n)}</strong>{' '}
          <span className="text-muted">({formataPct(dom.n, total)} do total)</span>
        </p>
        <ul className="list-unstyled mb-0" style={{ fontSize: '.9rem' }}>
          {resto.map((i) => (
            <li key={i.rotulo} className="d-flex justify-content-between border-bottom py-1">
              <span>{rotuloDe(i)}</span><span>{formata(i.n)}</span>
            </li>
          ))}
        </ul>
      </>
    );
  }

  const linhas = agrupaTopN(itens, topN, rotuloOutros);
  // larguras: todos os n = 0 davam width NaN%.
  const ws = larguras(linhas.map((i) => i.n), linhas[0].n);
  return (
    <ul className="list-unstyled mb-0">
      {linhas.map((i, k) => (
        <li key={i.rotulo} className="py-1">
          <div className="d-flex justify-content-between" style={{ fontSize: '.9rem' }}>
            <span>
              {rotuloDe(i)}
              {destaque && destaque(i) ? <small className="text-muted ml-1">· {destaque(i)}</small> : null}
            </span>
            <strong style={{ whiteSpace: 'nowrap', marginLeft: '.5rem' }}>{formata(i.n)}</strong>
          </div>
          <div className="painel-barra" aria-hidden="true" style={{ height: '6px' }}>
            <span style={{ width: `${ws[k]}%`, background: i.cor || cor }} />
          </div>
        </li>
      ))}
    </ul>
  );
}
